import { render, staticRenderFns } from "./TermsAndPrivacyPolicy.vue?vue&type=template&id=5bfa343a&scoped=true&"
import script from "./TermsAndPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./TermsAndPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndPrivacyPolicy.vue?vue&type=style&index=0&id=5bfa343a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfa343a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VContainer,VDivider})
